import React from 'react';

const GroundControlIcon = () => {
  return (
    <svg className="processing-diagram" viewBox="0 0 300 200" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="terrain-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#425b76" />
          <stop offset="100%" stopColor="#2d3e50" />
        </linearGradient>
      </defs>
      
      {/* Terrain base */}
      <path d="M30,160 C60,140 90,150 120,130 C150,110 180,120 210,100 C240,80 270,90 290,70 L290,160 L30,160 Z" 
            fill="url(#terrain-gradient)" opacity="0.7" />
      
      {/* Grid overlay */}
      <path d="M30,160 C60,140 90,150 120,130 C150,110 180,120 210,100 C240,80 270,90 290,70" 
            fill="none" stroke="#a0b4c8" strokeWidth="1" strokeDasharray="5,5" />
      
      {/* GCP markers */}
      <circle cx="60" cy="140" r="5" fill="#b33939" />
      <circle cx="150" cy="110" r="5" fill="#b33939" />
      <circle cx="240" cy="80" r="5" fill="#b33939" />
      
      {/* GCP tripods */}
      <line x1="60" y1="140" x2="50" y2="155" stroke="#a0b4c8" strokeWidth="2" />
      <line x1="60" y1="140" x2="70" y2="155" stroke="#a0b4c8" strokeWidth="2" />
      <line x1="60" y1="140" x2="60" y2="155" stroke="#a0b4c8" strokeWidth="2" />
      
      <line x1="150" y1="110" x2="140" y2="125" stroke="#a0b4c8" strokeWidth="2" />
      <line x1="150" y1="110" x2="160" y2="125" stroke="#a0b4c8" strokeWidth="2" />
      <line x1="150" y1="110" x2="150" y2="125" stroke="#a0b4c8" strokeWidth="2" />
      
      <line x1="240" y1="80" x2="230" y2="95" stroke="#a0b4c8" strokeWidth="2" />
      <line x1="240" y1="80" x2="250" y2="95" stroke="#a0b4c8" strokeWidth="2" />
      <line x1="240" y1="80" x2="240" y2="95" stroke="#a0b4c8" strokeWidth="2" />
      
      {/* LiDAR points */}
      <g fill="#a0b4c8" opacity="0.7">
        <circle cx="50" cy="145" r="1" />
        <circle cx="55" cy="142" r="1" />
        <circle cx="65" cy="138" r="1" />
        <circle cx="70" cy="142" r="1" />
        
        <circle cx="140" cy="115" r="1" />
        <circle cx="145" cy="112" r="1" />
        <circle cx="155" cy="108" r="1" />
        <circle cx="160" cy="112" r="1" />
        
        <circle cx="230" cy="85" r="1" />
        <circle cx="235" cy="82" r="1" />
        <circle cx="245" cy="78" r="1" />
        <circle cx="250" cy="82" r="1" />
      </g>
    </svg>
  );
};

export default GroundControlIcon;